import {
  isListItemPriority,
  isListItemStatus,
  PRIORITY_LABELS,
  STATUS_LABELS,
} from "@/features/shared/list-item-fields";
import { ListItemFrequency } from "@/types/openapi-enum";

/**
 * The fields the office list-item row renders — the widest shape shared by every v5 source
 * that feeds it: GetPlacesByPlaceIdResponse["listItems"] (Items tab), GetListItemsListItem
 * (pickers), GetOrdersByOrderIdResponse["listItems"] (order detail), GetSpacesBySpaceIdResponse["listItems"]
 * (space aside) and GetListItemsByListItemIdResponse (aside). Only `id` is guaranteed on all five.
 * The order and space sources carry no `workType` or `proposedBy`, so their rows show no tags.
 */
export type ListItemRow = {
  id: string;
  title?: string | null;
  status?: string | null;
  priority?: string | null;
  spaces?: Array<{ id: string; name: string }> | null;
  service?: { id: string } | null;
  workType?: string | null;
  proposedBy?: string;
  source?: string | null;
};

/** Born from an evaluator's to-do in a Mitti home evaluation (ListItem.source EVALUATION). */
export const isEvaluationListItem = (item: { source?: string | null }) =>
  item.source === "EVALUATION";

export const getListItemStatusLabel = (status: string) =>
  isListItemStatus(status) ? STATUS_LABELS[status] : "";

export const getPriorityLabel = (priority: string) =>
  isListItemPriority(priority) ? PRIORITY_LABELS[priority] : "";

export const getFrequencyLabel = (frequency: string) => {
  switch (frequency) {
    case ListItemFrequency.Once:
      return "Once";
    case ListItemFrequency.BiWeekly:
      return "Bi-weekly";
    case ListItemFrequency.Weekly:
      return "Weekly";
    case ListItemFrequency.Monthly:
      return "Monthly";
    case ListItemFrequency.Quarterly:
      return "Quarterly";
    case ListItemFrequency.Annual:
      return "Annually";
    case ListItemFrequency.BiAnnual:
      return "Bi-annually";
    default:
      return "";
  }
};
